export default "__VITE_ASSET__DbljJc8Z__"